import { requireAuth } from '@/features/auth/guards/require-auth'
import { usersListQuery } from '@/features/references/users/users-query'
import { warehousesListQuery } from '@/features/references/warehouses/queries/warehouse-query'
import { TransferCreatePage } from '@/features/transfers/pages/transfer-create-page'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/transfers/new')({
  beforeLoad: async (params) => {
    const ctx = await requireAuth(params)
    if (!ctx.user.is_staff) {
      throw redirect({ to: '/projects/' })
    }
    return ctx
  },
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(warehousesListQuery()),
      queryClient.ensureQueryData(usersListQuery()),
    ]),
  component: TransferCreatePage,
  staticData: { crumb: messages.crumbs.transferNew },
})
